"use client";

import { FC } from "react";

interface FlowButtonProps {
  buttonText?: string;
  onClick?: () => void;
  variant?: "primary" | "secondary";
}

const FlowButton: FC<FlowButtonProps> = ({
  buttonText = "",
  onClick = () => {},
  variant = "secondary",
}) => {
  if (!buttonText) return null;

  const commonMobileClass = "h-[40px] min-w-[206px] cursor-pointer rounded-[20px]";

  const buttonClass =
    variant === "primary"
      ? `${commonMobileClass} demat-button h-[40px] min-w-[206px] cursor-pointer rounded-[20px] bg-[linear-gradient(to_right,_#ff6700_67%,_#ff8900)] px-4 py-2 text-sm text-white`
      : `${commonMobileClass} rounded-full bg-gradient-to-r from-[#FF6700] to-[#FE8E0C] px-3 py-[11px] text-xs font-medium text-white uppercase md:w-full md:px-0 md:text-sm`;

  return (
    <button onClick={onClick} className={buttonClass}>
      <div className="flex items-center justify-center gap-1">
        <span>{buttonText}</span>

        <div className="flex">
          {[0, 0.2, 0.4].map((delay, index) => (
            <i
              key={`${index}-${delay}`}
              className="icomoon animated-button text-xs before:content-['\e911']"
              style={{ animationDelay: `${delay}s` }}
            />
          ))}
        </div>
      </div>
    </button>
  );
};

export default FlowButton;
